module.exports = __webpack_public_path__ + "static/media/exukonline_engines.7db3045a.jpg";